import { API_URL } from '../config/api';

/**
 * Permissions utility — loads user permissions from API and caches in localStorage.
 * Usage:
 *   await loadPermissions();          // call after login
 *   if (hasPermission('upload_files')) { ... }
 */

const STORAGE_KEY = 'user_permissions';

// All permissions default to true if not set
const DEFAULTS = {
  create_searches: true,
  manage_candidates: true,
  import_candidates: true,
  manage_client_firms: true,
  schedule_meetings: true,
  approve_reject: true,
  view_compensation: true,
  export_data: true,
  upload_files: true,
  manage_stages: true,
};

export async function loadPermissions() {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) return;
    const res = await fetch(`${API_URL}/user-management/my-permissions`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (res.ok) {
      const perms = await res.json();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(perms));
    }
  } catch (err) {
    console.error('Error loading permissions:', err);
  }
}

export function getPermissions() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return { ...DEFAULTS, ...JSON.parse(stored) };
  } catch {}
  return { ...DEFAULTS };
}

export function hasPermission(key) {
  const perms = getPermissions();
  return perms[key] !== false;
}

export function clearPermissions() {
  localStorage.removeItem(STORAGE_KEY);
}
